import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'

import {
  $convertToMarkdownString,
  TextFormatTransformer,
  TRANSFORMERS as DefaultTransformers
} from '@lexical/markdown'

const UNDERLINE_HTML: TextFormatTransformer = {
  format: ['underline'],
  tag: '<u>',
  type: 'text-format'
}

export const TRANSFORMERS = [UNDERLINE_HTML, ...DefaultTransformers]

export default function OnChangeMarkdownPlugin({
  onChange
}: {
  onChange: (markdown: string) => void
}) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerUpdateListener(() => {
      editor.read(() => {
        const markdown = $convertToMarkdownString(TRANSFORMERS)

        onChange(markdown)
      })
    })
  }, [editor, onChange])

  return null
}
